export default {
  org: [
    {
      orgNames: '保险代理（北京）有限公司陕西分公司',
      district: '陕西',
      orgCode: '201974610000800',
      foundedTime: '2017年3月22日',
      address: '陕西省西安市高新区丈八街办唐延南路都市之门C座1幢1单元10719室',
      supervision: '陕西银保监局'
    }, {
      orgNames: '安途保险代理（北京）有限公司山西分公司',
      district: '山西',
      orgCode: '201974140000800',
      foundedTime: '2018年1月9日',
      address: '山西省阳泉市城区平安路10-1-4',
      supervision: '山西银保监局'
    }, {
      orgNames: '安途保险代理（北京）有限公司上海第一分公司',
      district: '上海',
      orgCode: '201974310000800',
      foundedTime: '2016年8月16日',
      address: '上海市虹口区四平路257号名义25BH室',
      supervision: '上海银保监局'
    }, {
      orgNames: '安途保险代理（北京）有限公司',
      district: '北京',
      orgCode: '201974000000800',
      foundedTime: '2008年11月25日',
      address: '北京市西城区德胜门外大街36号楼5层2单元512',
      supervision: '北京银保监局'
    }, {
      orgNames: '安途保险代理（北京）有限公司江苏分公司',
      district: '江苏',
      orgCode: '201974320000800',
      foundedTime: '2016年7月19日',
      address: '无锡市经济开发区太湖新城金融一街1号1014-1016室',
      supervision: '江苏银保监局'
    }
  ]
}
